import {
    getFieldRegistration,
    getQueryRegistration,
    querySupplierById,
    ssoLink,
    updateFieldNew,
    updateSupplier
} from "@common/api"
import { accessToken, timeStamp } from "@common/utils"
import {
    mandatory_no_require,
    mandatory_require,
    type_checkbox,
    type_image, type_product_type,
    type_radio,
    type_text
} from "@common/constact"
import { uuid } from "@common/utils"
import { valueDuoxuanForPostStr } from "@common/utils"
import { GET_exhibit_detail, GET_supplierMap } from "./api"
import { isNil } from "@common/utils"
import { bodyAndValue2postObject } from "@common/utils"
import { createBodyMapBymergeBodyAndDataMap } from "@common/utils"
import { mergeBodyAndDefauts } from "@common/utils"

var initState = {
    id: "",
    exhibitId: "",
    userId: "",
    projectName: "",
    projectId: "",
    bodyMap: {},
    bodys: [],
    supplierMap: {},
    supplierMapAndbodys: [], //value
    isEdit: false,
    validateMessage: "",
    defaults: [],
    cascades: [],
}
export default {
    namespaced: true,
    state: initState,
    getters: {},
    mutations: {
        set_exhibitId (state, exhibitId) {
            state.exhibitId = exhibitId
        },
        set_projectName (state, projectName) {
            state.projectName = projectName
        },
        set_projectId (state, projectId) {
            state.projectId = projectId
        },
        set_userId (state, userId) {
            state.userId = userId
        },
        set_body (state, result) {
            state.bodys = result.body
            state.defaults = result.defaults
            state.cascades = result.cascades
        },
        togget_isEdit (state) {
            state.isEdit = !state.isEdit
        },
        set_isEdit_false (state) {
            state.isEdit = false
        },
        set_supplierMap (state, supplierMap) {
            state.supplierMap = supplierMap
            var bodys = mergeBodyAndDefauts(state.bodys, state.defaults)
            state.supplierMapAndbodys = createBodyMapBymergeBodyAndDataMap(bodys, supplierMap)
        },
        set_supplierMapAndbodys (state, supplierMapAndbodys) {
            state.supplierMapAndbodys = supplierMapAndbodys
        },
        set_messageError (state, validateMessage) {
            state.validateMessage = validateMessage
        }
    },
    actions: {
        async actions_fetch_get_body ({ state, commit }) {
            console.log('action------2')
            // get body
            var parmas = {
                accessToken: accessToken(),
                timeStamp: timeStamp(),
                src: '0',
                projectId: state.projectId
            }
            const res = await getQueryRegistration(parmas)
            if (res.code != 0) {
                throw res
            }
            commit("set_body", res.data)
            //get supplierMap
            var params2 = {
                accessToken: accessToken(),
                timeStamp: timeStamp(),
                projectId: state.projectId,
                id: state.userId
            }
            return querySupplierById(params2).then(res => {
                if (res.code != 0) {
                    throw res
                }
                commit("set_supplierMap", res.data && res.data.supplierMap)
            })
        },
        actions_validate_saveEdit ({ state, commit }) {
            //   那些必选拿到如果没有的话
            commit('set_messageError', ``)
            state.supplierMapAndbodys.map(item => {
                if (item.mandatory == mandatory_require && isNil(item.value)) {
                    commit('set_messageError', `${item.nameZh}必填`)
                    return false
                }
            })
            return !state.validateMessage
        },
        actions_saveEdit ({ state, commit }) {
            var data = bodyAndValue2postObject(state.supplierMapAndbodys)
            let params = {
                accessToken: accessToken(),
                timeStamp: timeStamp(),
                projectId: state.projectId,
                src: '0',
                userId: state.userId,
                data: data
            }
            return updateSupplier(params).then(res => {
                if (res.code != '0') {
                    throw res
                }
                return res
            })
        }


    }
}


// WEBPACK FOOTER //
// ./src/admin/components/organizer/toSupplierDetail/toSupplierDetailStore.js